import Placeholder from "components/Placeholder";

import { StyledContainer, Title, Description } from "../styles";

const LoadingHeader = () => {
  return (
    <StyledContainer data-testid="pageHeader-placeholder">
      <Title align="center" variant="h1">
        <Placeholder variant="text" width={350} />
      </Title>
      <Description align="center" variant="large">
        <Placeholder variant="text" width={350} />
      </Description>
    </StyledContainer>
  );
};

export default LoadingHeader;
